import s from "./RegionalRepresentatives.module.scss";
import { MailOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { TableType } from "./representativesData";

type Props = {
  data: TableType[];
};

// Phones: one card per country instead of the wide table, same data as desktop
const MobileRegionalRepresentatives = ({ data }: Props) => (
  <div className={s.m_list}>
    {data.map((it) => {
      const company = typeof it.company === "object" ? it.company : {};
      const empty = !it.representative && !company.phone && !company.email;

      return (
        <div key={it.key} className={s.m_card}>
          <div className={s.m_head}>
            <img src={it.flag} alt="" className={s.m_flag} />
            <span>{it.country}</span>
          </div>

          {empty ? (
            <div className={s.m_empty}>—</div>
          ) : (
            <div className={s.m_body}>
              {it.representative && (
                <div className={s.m_row}>
                  <UserOutlined className={s.icon} />
                  {it.representative}
                </div>
              )}
              {company.phone && (
                <a className={s.m_row} href={`tel:${company.phone.replace(/\s/g, "")}`}>
                  <PhoneOutlined className={s.icon} />
                  {company.phone}
                </a>
              )}
              {company.email && (
                <a className={s.m_row} href={`mailto:${company.email}`}>
                  <MailOutlined className={s.icon} />
                  {company.email}
                </a>
              )}
            </div>
          )}
        </div>
      );
    })}
    <div className={s.m_footer}>{data.length} countries</div>
  </div>
);

export default MobileRegionalRepresentatives;
